var React = require('react');

function Firewall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 33a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h18zm26 0a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H28a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h18zM32 19a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16zM20 5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h18zm26 0a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H28a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h18z","fill":"#55FF8A","key":0}),React.createElement("path",{"opacity":".498","d":"M8 19H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM46 19h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z","fill":"#55FF8A","key":1})]);
}

Firewall.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Firewall;

Firewall.default = Firewall;
